

import { useParams } from 'react-router'
import { ComponentWithPermissions } from '../../../../../../../../../baseComponents/CreateRoutering/types'
import { permissionCheck } from '../../../../../../../../../baseComponents/PermissionChecker/function'
import TwinTable from '../../../../../../../../../baseComponents/TwinTable'
import BaseScreenTableInner from '../../../../../../../../../baseComponents/TwinTable/BaseScreenTableInner'
import { TableComponentBaseScreenInnerProps } from '../../../../../../../../../baseComponents/TwinTable/BaseScreenTableInner/types'
import { CustomRenderString, DeleteRow, EditRowNotLink } from '../../../../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import useTwinTranslation from '../../../../../../../../../utils/hooks/useTwinTranslation'
import { WCalEmployeeAgreementHoursModelType } from '@teinor/erp/types/company/WCalParent/WCal/WCalEmployeeAgreementHours'
import ModalCEEmployeeAgreementHours from './ModalCEEmployeeAgreementHours'
import ModalDeleteEmployeeAgreementHours from './ModalDeleteEmployeeAgreementHours'
import { displayFormatedHourFromMins } from '../../../../../../../../../utils/globals/date'


interface EmployeeAgreementHoursProps extends ComponentWithPermissions { }

const EmployeeAgreementHours: React.FC<EmployeeAgreementHoursProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()
    const params = useParams<{ id: string }>()
    const id = params.id
    const pageData = {
        title: t('agreementHours', 'Horas convenio'),
        newText: t('addAgreementHours', 'Añadir horas convenio'),
    }

    return (
        <BaseScreenTableInner TableComponent={TableEmployeeAgreementHours} pageData={pageData} CreateModalComponent={ModalCEEmployeeAgreementHours} EditModalComponent={ModalCEEmployeeAgreementHours} DeleteModalComponent={ModalDeleteEmployeeAgreementHours} userPermissions={userPermissions} extraWhereParams={{ 'EmployeeId': id }} />
    )
}

interface TableEmployeeAgreementHoursProps extends TableComponentBaseScreenInnerProps { }

const TableEmployeeAgreementHours: React.FC<TableEmployeeAgreementHoursProps> = ({ setTableInstance, userPermissions, extraWhereParams, setOpened }) => {
    const { t } = useTwinTranslation()
    const columns: ColumnTableSchema<WCalEmployeeAgreementHoursModelType> = [
        {
            id: 'id',
            dataKey: 'id',
            label: t('id', 'ID'),
            sortable: true,
            width: 100
        },
        {
            id: 'year',
            dataKey: 'year',
            label: t('year', 'Año'),
            minWidth: 130,
            sortable: true,
        },
        {
            id: 'totalMins',
            dataKey: 'totalMins',
            label: t('totalMins', 'Horas totales convenio'),
            minWidth: 130,
            customRender: (parameterValue) => <CustomRenderString value={displayFormatedHourFromMins(parseInt(parameterValue))} />,
        },
        {
            id: 'restMins',
            dataKey: 'restMins',
            label: t('restMins', 'Horas a deber'),
            customRender: (parameterValue) => <CustomRenderString value={displayFormatedHourFromMins(parseInt(parameterValue))} />
        },
        {
            id: 'edit',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('edit', 'Editar'),
            customRender: (parameterValue, allRowData) => <EditRowNotLink key={'edit' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'edit', allRowData })} />,
        },
        {
            id: 'delete',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('delete', 'Eliminar'),
            customRender: (parameterValue, allRowData) => <DeleteRow key={'delete' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'delete', allRowData })} />,
            havePermission: permissionCheck(userPermissions, 'delete')
        }
    ]
    return (
        <TwinTable name='employeeAgreementHours' columns={columns} getDataFrom='/api/app/workingCalendar/agreementHours/getAllWCalEmployeeAgreementHours'
            onRowClick={(_id, rowData) => setOpened({
                type: 'edit',
                allRowData: rowData
            })} setTableInstance={setTableInstance} extraWhereParams={extraWhereParams} defaultOrder={{ order: 'desc', defaultOrderField: 'year' }} />
    )
}


export default EmployeeAgreementHours